export default "__VITE_ASSET__3864524d__"